<header>
  <nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-{{siteId}}">
    <a class="navbar-brand" href="#">BCRA-MIF</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
      aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
      <div class="navbar-nav">
        <a [routerLink]="['/home']" routerLinkActive="active" class="nav-item nav-link">Home</a>
        <a [routerLink]="['/tickets']" *ngIf="isAuthenticated" routerLinkActive="active"
          class="nav-item nav-link">Gestionar Tickets</a>
        <a [routerLink]="['/entidades-habilitadas']" *ngIf="isAuthenticated" routerLinkActive="active"
          class="nav-item nav-link">Entidades Habilitadas</a>
        <a [routerLink]="['/users']" *ngIf="isAuthenticated" routerLinkActive="active"
          class="nav-item nav-link">Usuarios</a>
        <a [routerLink]="['/operators']" *ngIf="isAuthenticated" routerLinkActive="active" class="nav-item nav-link"
          hidden>Operadores</a>
        <a [routerLink]="['/applications']" *ngIf="isAuthenticated" routerLinkActive="active" class="nav-item nav-link"
          hidden>Aplicaciones</a>
        <a [routerLink]="['/nodes']" *ngIf="isAuthenticated" routerLinkActive="active" class="nav-item nav-link"
          hidden>Nodos</a>
        <a [routerLink]="['/accounts']" *ngIf="isAuthenticated" routerLinkActive="active" class="nav-item nav-link"
          hidden>Cuentas</a>
        <a [routerLink]="['/admins']" *ngIf="isAuthenticated" routerLinkActive="active" class="nav-item nav-link"
          hidden>Administradores</a>
      </div>
    </div>
    <form class="form-inline">
      <div class="navbar-nav text-center">
        <div class="text-center mt-3">
          <button *ngIf="!isAuthenticated" class="btn btn-sm btn-primary mx-1" type="button"
            (click)="login()">Login</button>
          <button *ngIf="isAuthenticated" class="btn btn-sm btn-secondary mx-1" type="button"
            (click)="logout()">Logout</button>
        </div>
      </div>
    </form>
  </nav>
</header>
<div class="progress" *ngIf="loadingService.isLoading()">
  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75"
    aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
</div>
<main class="container">
  <router-outlet></router-outlet>
</main>

<footer class="bg-dark">
  <div class="container text-right">
    <small>Power by <a href=" https://www.rsk.co/" target="_blank">RSK</a> Enterprise and Developed by <a
        href=" www.incucai.com" target="_blank">Grupo Sabra</a> </small>
  </div>
</footer>